/**
 * @file useAdminUserDetail.js
 *
 * Hook for viewing a single user's full details (profile, appointments, audit trail)
 * and performing admin actions (delete, impersonate).
 */
import { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { adminService } from "../services/admin";

/**
 * @param {number} userId
 * @returns {{ user: Object|null, isLoading: boolean, refresh: Function, deleteUser: Function, impersonate: Function }}
 */
export function useAdminUserDetail(userId) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    if (!userId) return;
    try {
      setIsLoading(true);
      const res = await adminService.getUserDetail(userId);
      setUser(res.data);
    } catch {
      // Handled by interceptor
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  useEffect(() => { fetchUser(); }, [fetchUser]);

  const deleteUser = async () => {
    await adminService.deleteUser(userId);
    toast.success("Usuario eliminado");
  };

  const impersonate = async () => {
    const res = await adminService.impersonateUser(userId);
    return res.data; // { token, user }
  };

  return { user, isLoading, refresh: fetchUser, deleteUser, impersonate };
}
